import controller from './vd-scrollable.controller'

const ScrollableComponent = {
  controller,
  bindings: {
    monobrow: '<?',
    goatee: '<?',
  },
  template: `
     <div class="vd-scrollable-indicator vd-scrollable-monobrow"></div>
     <div class="vd-scrollable" ng-transclude></div>
     <div class="vd-scrollable-indicator vd-scrollable-goatee"></div>
   `,
  transclude: true,
}

export default ScrollableComponent
